import React from 'react';
import PropTypes from 'prop-types';

import Message from './message';

const styles = {
  messageBox: {
    padding: '0 15px',
  },
  messageBoxSmall: {
    padding: '0 0 15px',
  },
};

const MessageBox = (props) => {
  const { messages, useDesktopLayout, removeMessageByIndex } = props;

  if (!messages || messages.length < 1) {
    return null;
  }

  const messageItems = messages.map((message, index) => (
    <Message
      key={message.message}
      {...message}
      onClose={() => removeMessageByIndex(index)}
    />
  ));
  return (
    <div style={useDesktopLayout ? styles.messageBox : styles.messageBoxSmall}>
      {messageItems}
    </div>
  );
};

MessageBox.propTypes = {
  messages: PropTypes.array,
  useDesktopLayout: PropTypes.bool,
  removeMessageByIndex: PropTypes.func,
};

MessageBox.defaultProps = {
  messages: [],
  useDesktopLayout: true,
  removeMessageByIndex: () => {},
};

export default MessageBox;
